var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{attrs:{"showUploadList":false,"accept":".srt,.vtt","name":"file","customRequest":_vm.handleChangeEn}},[(_vm.customType == 1 ? _vm.customInfo.subtitleCn :
    _vm.customType == 2 ? _vm.customInfo.subtitle :
    _vm.customType == 3 ? _vm.customInfo.subtitleEn : _vm.customType == 4 ? _vm.customInfo.subtitleBm : _vm.customInfo.subtitleIn)?_c('a-button',{attrs:{"type":"primary"}},[_vm._v("更换")]):_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 上传 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }